import { DataTypes } from "@lexriver/data-types";


export interface JsonShippingAddress {
    userId:number

    company:string
    firstName:string
    lastName:string
    middleName:string
    zipCode:number
    //countryCode:string
    country:string
    city:string
    address:string
    phone:string
    inn:string


}

export function isValidJsonShippingAddress(x:any){
    return x.userId && DataTypes.isNumber(x.userId) &&
        x.company && DataTypes.isString(x.company) &&
        x.city && DataTypes.isString(x.city) &&
        x.address && DataTypes.isString(x.address)
}